import type { ImgCdnParameters } from './types';

export class ImgCdnUrlBuilder {
  private url: URL;

  constructor(url: string) {
    this.url = new URL(url);
  }

  setBaseUrl(baseUrl: string): ImgCdnUrlBuilder {
    this.url.hostname = baseUrl;
    return this;
  }

  setPath(path: string): ImgCdnUrlBuilder {
    const basePath = this.url.pathname.replace(/\/$/, '');
    const stringPath = String(path);
    const normalizedPath = stringPath.startsWith('/') ? stringPath : `/${stringPath}`;
    this.url.pathname = `${basePath}${normalizedPath}`;
    return this;
  }

  addParameter<TImgCdnParameter extends keyof ImgCdnParameters>(
    key: TImgCdnParameter,
    value: ImgCdnParameters[TImgCdnParameter]
  ): ImgCdnUrlBuilder {
    this.url.searchParams.set(key, value);
    return this;
  }

  removeParameter<TImgCdnParameter extends keyof ImgCdnParameters>(key: TImgCdnParameter): ImgCdnUrlBuilder {
    this.url.searchParams.delete(key);
    return this;
  }

  hasParameter<TImgCdnParameter extends keyof ImgCdnParameters>(
    key: TImgCdnParameter,
    value?: ImgCdnParameters[TImgCdnParameter]
  ): boolean {
    return this.url.searchParams.has(key, value);
  }

  public build(): string {
    return this.url.toString();
  }
}
